import { addMessages, getLocaleFromNavigator, init } from 'svelte-i18n';

import en from './../locales/en.json';
import it from './../locales/it.json';
import es from './../locales/es.json';
import pl from './../locales/pl.json';


addMessages('en', en);
addMessages('it', it);
addMessages('es', es);
addMessages('pl', pl);

export class i18n {
  static get language() {
    return localStorage.getItem('app_lang') || getLocaleFromNavigator()
  }

  static set language(lang_id) {
    localStorage.setItem('app_lang', lang_id)
  }

}

init({
  fallbackLocale: 'en',
  initialLocale: i18n.language,
});